import { render, staticRenderFns } from "./ZonePriceTableAdmin.vue?vue&type=template&id=2d1a0614&scoped=true"
import script from "./ZonePriceTableAdmin.vue?vue&type=script&lang=js"
export * from "./ZonePriceTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a0614",
  null
  
)

export default component.exports